import React from 'react';

function IntroBlock({ t }){
  if (t) {
    return (
      <div className="homePage-intro" tabIndex="0">
        <div className="wrap">
          <h3>{t("introHeader")}</h3>
          <p dangerouslySetInnerHTML={{ __html: t("introParagraph") }} />
        </div>
      </div>
    );
  }

  // Fallback for safety (original logic)
  return(
    <div className="homePage-intro" tabIndex="0">
      <div className="wrap">
        <h3>How TrackMyDown Works</h3>
        <p>
          ALLIED has developed TrackMyDown so you can better understand the premium down products keeping you warm. It&#39;s important to know where your down has come from and to be assured that it has been responsibly&nbsp;sourced. <br/><br/> With TrackMyDown you now have the power to better understand all the nuances of down and make a more-informed decision based on the performance and sustainability of the exact insulation inside the&nbsp;product.
        </p>
      </div>
    </div>
  );
}  

export default IntroBlock;